import { FC } from 'react';
import MuiLink from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

const linkStyle = css`
  &&& {
    text-decoration: none;
    color: inherit;

    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
      text-decoration: none;
      color: inherit;
    }
  }
`;

const StyledMuiLink = styled(MuiLink)`
  ${linkStyle}
`;

const StyledRouterLink = styled(RouterLink)`
  ${linkStyle}
`;

interface LinkProps {
  to: string;
  external?: boolean;
}

export const Link: FC<LinkProps> = ({ to, external, children }) => {
  if (external) {
    return (
      <StyledMuiLink target="_blank" href={to}>
        {children}
      </StyledMuiLink>
    );
  }

  return (
    <StyledRouterLink to={to}>
      <StyledMuiLink>{children}</StyledMuiLink>
    </StyledRouterLink>
  );
};
